import { API } from '.'
import { handleResponse } from '../helpers';
import { API_URL } from '../config/appConfig';

const basePath = `${API_URL.idp}/system/tenant`;

const getAllTenants = async () => {
    return API.get(basePath, "all_tenants").then(handleResponse);
};

const getTenantById = async (tenantId) => {
    return API.get(`${basePath}/${tenantId}`, "system_tenant_by_id").then(handleResponse);
};

const createTenant = async (payload) => {
    // Create: name, email, contactPerson only (mobile is update-only).
    return API.post(basePath, "system_tenant_create", {
        name: payload.name,
        email: payload.email,
        contactPerson: payload.contactPerson,
    }).then(handleResponse);
};

const updateTenant = async (tenantId, payload) => {
    // `name` is immutable after create. Mobile must be E.164.
    const body = {
        email: payload.email,
        contactPerson: payload.contactPerson,
    };
    if (payload.mobile) {
        body.mobile = payload.mobile;
    }
    return API.put(`${basePath}/${tenantId}`, "system_tenant_update", body).then(
        handleResponse
    );
};

const updateTenantEnabled = async (tenantId, enabled) => {
    const nextEnabled = Boolean(enabled);
    return API.put(
        `${basePath}/${tenantId}/${nextEnabled ? "enable" : "disable"}`,
        "system_tenant_enable_disable",
        { enabled: nextEnabled }
    ).then(handleResponse);
};

const deleteTenant = async (tenantId) => {
    return API.delete(`${basePath}/${tenantId}`, "system_tenant_delete").then(handleResponse);
};

export const tenantmgmtService = {
    getAllTenants,
    getTenantById,
    createTenant,
    updateTenant,
    updateTenantEnabled,
    deleteTenant,
};
